export default __webpack_public_path__ + "static/media/image3-mobile.8059967c.png";